// Regions/States/Provinces for Mediterranean countries (simplified - expand as needed)

export const MEDITERRANEAN_REGIONS: Record<string, string[]> = {
  'Spain': ['Andalusia', 'Catalonia', 'Madrid', 'Valencia', 'Basque Country'],
  'France': ['Île-de-France', 'Provence-Alpes-Côte d\'Azur', 'Occitanie', 'Nouvelle-Aquitaine'],
  'Italy': ['Lombardy', 'Lazio', 'Campania', 'Sicily', 'Piedmont'],
  'Tunisia': ['Tunis', 'Sfax', 'Sousse', 'Nabeul', 'Bizerte', 'Ariana'],
  'Morocco': ['Casablanca-Settat', 'Rabat-Salé-Kénitra', 'Marrakech-Safi', 'Fès-Meknès'],
  'Algeria': ['Algiers', 'Oran', 'Constantine', 'Annaba', 'Sétif'],
  'Egypt': ['Cairo', 'Alexandria', 'Giza', 'Suez', 'Port Said'],
  'Turkey': ['Istanbul', 'Ankara', 'İzmir', 'Antalya', 'Bursa'],
  'Greece': ['Attica', 'Central Macedonia', 'Crete', 'Thessaly'],
  'Lebanon': ['Beirut', 'Mount Lebanon', 'North', 'South', 'Bekaa'],
};

export const MEDITERRANEAN_REGION_CITIES: Record<string, Record<string, string[]>> = {
  France: {
    'Île-de-France': ['Paris', 'Versailles', 'Boulogne-Billancourt', 'Saint-Denis', 'Nanterre'],
    'Provence-Alpes-Côte d\'Azur': ['Marseille', 'Nice', 'Toulon', 'Aix-en-Provence', 'Avignon'],
    Occitanie: ['Toulouse', 'Montpellier', 'Nîmes', 'Perpignan', 'Carcassonne'],
    'Nouvelle-Aquitaine': ['Bordeaux', 'Limoges', 'Poitiers', 'La Rochelle', 'Pau'],
  },
  Spain: {
    Andalusia: ['Seville', 'Málaga', 'Granada', 'Córdoba', 'Cádiz'],
    Catalonia: ['Barcelona', 'Tarragona', 'Girona', 'Lleida', 'Sabadell'],
    Madrid: ['Madrid', 'Alcalá de Henares', 'Getafe', 'Móstoles', 'Leganés'],
    Valencia: ['Valencia', 'Alicante', 'Castellón', 'Elche', 'Torrevieja'],
    'Basque Country': ['Bilbao', 'Vitoria-Gasteiz', 'San Sebastián', 'Barakaldo', 'Getxo'],
  },
  Tunisia: {
    Tunis: ['Tunis', 'La Marsa', 'Carthage', 'Sidi Bou Said', 'Ariana'],
    Sfax: ['Sfax', 'Skhira', 'Mahares', 'Agareb'],
    Sousse: ['Sousse', 'Monastir', 'Mahdia', 'Msaken', 'Kalaa Kebira'],
    Nabeul: ['Nabeul', 'Hammamet', 'Korba', 'Kelibia', 'Dar Chaabane'],
    Bizerte: ['Bizerte', 'Menzel Bourguiba', 'Ras Jebel', 'Mateur'],
    Ariana: ['Ariana', 'La Soukra', 'Raoued', 'Ettadhamen'],
  },
  Morocco: {
    'Casablanca-Settat': ['Casablanca', 'Mohammedia', 'Settat', 'El Jadida', 'Benslimane'],
    'Rabat-Salé-Kénitra': ['Rabat', 'Salé', 'Kénitra', 'Témara', 'Skhirat'],
    'Marrakech-Safi': ['Marrakech', 'Safi', 'Essaouira', 'Youssoufia', 'Chichaoua'],
    'Fès-Meknès': ['Fès', 'Meknès', 'Taza', 'Ifrane', 'Sefrou'],
  },
};

// Helper function to get regions for a country
export const getRegionsByCountry = (countryName: string): string[] => {
  return MEDITERRANEAN_REGIONS[countryName] || [];
};

/** Returns cities deduplicated (no repeated names), order preserved */
function uniqueCities(cities: string[]): string[] {
  return Array.from(new Set(cities));
}

// Helper to get cities for a given country + region (unique only, no repeats)
export const getCitiesByCountryAndRegion = (countryName: string, regionName: string): string[] => {
  const raw = MEDITERRANEAN_REGION_CITIES[countryName]?.[regionName] || [];
  return uniqueCities(raw);
};

/** City options for address: unique cities when available, otherwise regions list so the field is always a dropdown */
export const getCityOptionsForAddress = (countryName: string, regionName: string): string[] => {
  const raw = MEDITERRANEAN_REGION_CITIES[countryName]?.[regionName];
  if (raw && raw.length > 0) return uniqueCities(raw);
  return getRegionsByCountry(countryName);
};
